export const airportChange = `
<div class="modal-header-wrapper">  
    <h3 class="lead">Aviso:</h3>
    <p>Seu voo contêm <strong>troca de aeroporto</strong> durante a conexão. A companhia aérea não fornece o transporte entre os aeroportos.</p>
</div>
<div class="row">
   <div class="col-xs-16 col-md-8">
        <a href="#" title="Voltar" id="btn_back_airport_change" class="btn btn-default btn-go">
            <i class="icon-arrow-left"></i>Voltar
        </a>         
   </div>
   <div class="col-xs-16 col-md-8">
        <a href="#" title="Continuar" id="btn_continue_to_checkout" class="btn btn-success btn-back">
            <i class="icon-arrow-right"></i>Continuar
        </a>        
   </div>
</div>`;
